import _ from 'lodash'
const preloadImg = (url) => new Promise((resolve, reject) => {
  const img = document.createElement('img')
  img.onload = () => resolve(url)
  img.src = url
})

export default _.memoize(preloadImg)
